const box = {
  width: '100%',
  padding: 16,
};

const title = {
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: 15,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

const styles = (theme) => ({
  root: {
    ...box,
    overflow: 'hidden',
    height: '100%',
    marginBottom: 24,
  },

  noPadding: {
    padding: 0,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  actions: {
    flexShrink: 0,
  },

  paddedTitle: {
    ...title,
    padding: 16,
  },

  title: {
    ...title,
    padding: theme.titlePadding,
    marginBottom: -theme.titlePadding,
  },
});

export default styles;
